import { useMutation, useQuery } from "@apollo/client";
import React, { useState } from "react";
import {
  NavLink,
  Link,
  useParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Icons from "../../assets/icons/index.jsx";
import Images from "../../assets/images/index.jsx";
import { GET_Bookmarked_Video } from "../../gql/mutation.jsx";
import { GET_Video_Layer } from "../../gql/queries.jsx";
import {
  getPercentage,
  getProgressPercentage,
  getProgressVideoPercentage,
  getProgressvideoPercentage,
  getTime,
  getVideoTime,
} from "../../utils/index.js";
import Modal from "react-bootstrap/Modal";
import NoDataFound from "../common/NoDataFound/NoDataFound.jsx";
import { authorizationCheck } from "../../utils/logout.jsx";
import Loader from "../common/Loader/Loader.jsx";
import { decryptdata, decrypt } from "../../utils/crypto.jsx";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong.jsx";
import ConnectionError from "../common/NoDataFound/ConnectionError.jsx";
import { trackEvent } from "../../../src/utils/moengageUserSetup";
export default function VideoLayerContent() {
  let location = useLocation();
  var topicId = location.state;
  let { id } = useParams();
  const navigate = useNavigate();
  const [version, setVersion] = useState(
    JSON.parse(localStorage.getItem("version"))
  );
  const [language, setLanguage] = useState(
    JSON.parse(localStorage.getItem("language"))
  );
  const [course, setCourse] = useState(
    JSON.parse(decrypt(localStorage.getItem("profileDetails")))
  );
  const [show, setShow] = useState(false);
  const packageStatus = JSON.parse(
    decrypt(localStorage.getItem("packageStatus"))
  );
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // trackEvent("ViewedWebPage", {
  //   url: window.location.href,
  //   timestamp: Date.now(),
  // });
  const [getBookmark] = useMutation(GET_Bookmarked_Video, {
    refetchQueries: [
      {
        query: GET_Video_Layer,
        variables: {
          _id: id,
          language: language,
          contentType: "videos",
        },
      }, // DocumentNode object parsed with gql
      "videolayer", // Query name,
    ],
    context: {
      headers: {
        deviceId: decryptdata(localStorage.getItem("dId")),
      },
    },
  });
  const query1 = useQuery(GET_Video_Layer, {
    variables: {
      _id: id,
      language: language,
      contentType: "videos",
    },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      console.log(data)
      trackEvent("viewVideo", {
        "type": "video", "parent": data?.layer?.parents, "title": data?.layer?.title
      });
    },
  });
  const query2 = useQuery(GET_Video_Layer, {
    variables: {
      _id: topicId,
      language: language,
      contentType: "videos",
    },
    fetchPolicy: "network-only",
  });
  if (query1?.loading || query2?.loading)
    return (
      <>
        <Loader />
      </>
    );
  if (query1?.error || query2?.error) {
    if (
      query1?.error?.graphQLErrors.some(
        (e) => e?.extensions?.code === "UNAUTHENTICATED"
      ) ||
      query2?.error?.graphQLErrors.some(
        (e) => e?.extensions?.code === "UNAUTHENTICATED"
      )
    ) {
      authorizationCheck(navigate);
    } else if (
      query1?.error?.graphQLErrors.some(
        (e) => e.extensions?.code === "INTERNAL_SERVER_ERROR"
      ) ||
      query2?.error?.graphQLErrors.some(
        (e) => e?.extensions?.code === "INTERNAL_SERVER_ERROR"
      )
    ) {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <SomethingWentWrong pathName={location?.pathname} />
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <ConnectionError pathName={location?.pathname} />
            </div>
          </div>
        </>
      );
    }
    // console.log(query1.error.graphQLErrors);
    // console.log(query2.error.graphQLErrors);
  }
  let topiclist;
  query2?.data &&
    query2?.data?.layer?.subLayers.map((obj) => {
      if (obj.layerType === "topic_list") {
        topiclist = obj.subLayers;
        return;
      }
    });
  let allVideoList = [];
  if (query1?.data?.layer && query1?.data?.layer?.subContents !== null) {
    query1?.data &&
      query1?.data?.layer?.subContents.map((obj) => {
        // if (obj?.video?.progress?.isCompleted == null) {
        allVideoList.push(obj);
        return;
        // }
      });
  }

  let notStartList = [];
  if (query1?.data?.layer && query1?.data?.layer?.subContents !== null) {
    query1?.data &&
      query1?.data?.layer?.subContents.map((obj) => {
        if (obj?.video?.progress?.isCompleted == null) {
          notStartList.push(obj);
          return;
        }
      });
  }

  let countinousList = [];
  if (query1?.data?.layer && query1?.data?.layer?.subContents !== null) {
    query1?.data &&
      query1?.data?.layer?.subContents.map((obj) => {
        if (obj?.video?.progress?.isCompleted === false) {
          countinousList.push(obj);
          return;
        }
      });
  }

  let completedList = [];
  if (query1?.data?.layer && query1?.data?.layer?.subContents !== null) {
    query1?.data &&
      query1?.data?.layer?.subContents.map((obj) => {
        if (obj?.video?.progress?.isCompleted === true) {
          completedList.push(obj);
          return;
        }
      });
  }

  const bookmarked = (d) => {
    let duration = {
      duration: d?.video?.progress?.duration
        ? parseInt(d?.video?.progress?.duration[0]?.duration)
        : 0,
      language: d?.video?.progress?.duration
        ? d.video?.progress?.duration[0].language
        : "English",
    };
    // console.log(duration,"durationInput",d)
    getBookmark({
      variables: {
        contentType: "Videos",
        topicId: d?.video?.subjectDetail?.topicId,
        subjectId: d?.video?.subjectDetail?.subjectId,
        contentId: d?.video?._id,
        isCompleted:
          d.video.progress.isCompleted == null
            ? false
            : d.video.progress.isCompleted,
        courseName: course.preparingFor,
        duration: duration,
        isBookMarked: !d.video.progress.isBookMarked,
        status: "Pause",
        version: parseFloat(version?.actual),
      },
    });
  };

  return (
    <>
      <div className="main_wrapper">
        <div className="breadcrumbs">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Home</a>
            </li>
            <li className="breadcrumb-item">Video</li>
            <li className="breadcrumb-item">
              {query2.data ? query2.data.layer.title : ""}
            </li>
            <li className="breadcrumb-item active">
              {query1.data.layer ? query1.data.layer.title : ""}
            </li>
          </ul>
        </div>
        <section className="videoLayer_wrapper videoLayer_content_wrapper section_side_padding">
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-12">
              <div className="topics_wrapper_main">
                <div className="subjects_wrapper topic_header">
                  <div className="topic_header_content d-flex align-items-center">
                    <div className="topic_image_ttl d-flex align-items-center">
                      <Link to={`/videolayer/${topicId}`}>
                        <figure className="back_arrow">
                          <img
                            src={Icons.BackArrow}
                            alt="Back Arrow"
                            className="img-fluid"
                          />
                        </figure>
                      </Link>
                      <figure className="subject_inner_img">
                        <img
                          src={
                            query1.data.layer.icon
                              ? query1.data.layer.icon
                              : Images.defaultImg
                          }
                          alt="Subject Image"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="subject_ttl_detail">
                        <h5>{query1.data ? query1.data.layer.title : ""}</h5>
                        <p>
                          <span>by</span>{" "}
                          {query1.data.layer.author
                            ? query1.data.layer.author.name
                            : ""}
                        </p>
                      </div>
                    </div>
                    {/* <div className="search_icon">
                                            <img src={Icons.SearchIcon} alt="" className="img-fluid" />
                                        </div> */}
                  </div>
                  <div className="progress_bar">
                    <div className="progress_details d-flex align-items-center">
                      {getPercentage(
                        query1.data.layer ? query1.data.layer : 0
                      ) !== 100 && (
                          <div className="progress">
                            <div
                              className="progress-bar"
                              style={{
                                width: `${getPercentage(
                                  query1.data.layer ? query1.data.layer : 0
                                )}%`,
                              }}
                            ></div>
                          </div>
                        )}
                      {getPercentage(
                        query1.data.layer ? query1.data.layer : 0
                      ) === 100 && (
                          <div className="progress">
                            <div
                              className="progress-bar completed"
                              style={{
                                width: `${getPercentage(
                                  query1.data.layer ? query1.data.layer : 0
                                )}%`,
                              }}
                            ></div>
                          </div>
                        )}

                      <div className="completed_text">
                        <span>{`${getPercentage(
                          query1.data ? query1.data.layer : 0
                        )}%`}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="recommended_video_wrapper videoMainContent">
                  <div className="main_tabs_wrapper">
                    <div className="tabs_main_wrap">
                      <div className="tabs_main">
                        <ul className="nav nav-tabs">
                          <li
                            className="nav-item"
                            onClick={() => query1.refetch(GET_Video_Layer)}
                          >
                            <a
                              className="nav-link active"
                              data-toggle="tab"
                              href="#videos"
                            >
                              All Videos{" "}
                              <span>
                                (
                                {query1.data.layer.subContents != undefined
                                  ? query1.data.layer.subContents.length
                                  : 0}
                                )
                              </span>
                            </a>
                          </li>
                          <li
                            className="nav-item"
                            onClick={() => query1.refetch(GET_Video_Layer)}
                          >
                            <a
                              className="nav-link"
                              data-toggle="tab"
                              href="#started"
                            >
                              Not Started{" "}
                              <span>
                                (
                                {notStartList.length != 0
                                  ? notStartList.length
                                  : 0}
                                )
                              </span>
                            </a>
                          </li>
                          <li
                            className="nav-item"
                            onClick={() => query1.refetch(GET_Video_Layer)}
                          >
                            <a
                              className="nav-link"
                              data-toggle="tab"
                              href="#progress"
                            >
                              In-progress{" "}
                              <span>
                                (
                                {countinousList.length != 0
                                  ? countinousList.length
                                  : 0}
                                )
                              </span>
                            </a>
                          </li>
                          <li
                            className="nav-item"
                            onClick={() => query1.refetch(GET_Video_Layer)}
                          >
                            <a
                              className="nav-link"
                              data-toggle="tab"
                              href="#completed"
                            >
                              Completed{" "}
                              <span>
                                (
                                {completedList.length != 0
                                  ? completedList.length
                                  : 0}
                                )
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="tab-content">
                      <div className="tab-pane active" id="videos">
                        <div className="recommend_video_details">
                          <ul type="none" className="recommend_list">
                            {allVideoList &&
                              allVideoList.map((d, i) => (
                                <li>
                                  <div className="recommend_list_main d-flex align-items-center">
                                    <figure
                                      className="user_img"
                                      onClick={handleShow}
                                    >
                                      <img
                                        src={
                                          d?.video?.thumbnail
                                            ? d?.video?.thumbnail
                                            : Images.defaultVideo
                                        }
                                        alt=""
                                        className="img-fluid"
                                      />
                                      {d?.video?.purchaseStatus != 0 && (
                                        <figcaption className="free_tag">
                                          <span>
                                            <img
                                              src={Icons.Lock}
                                              alt="Lock"
                                              className="img-fluid"
                                            />{" "}
                                            Pro
                                          </span>
                                        </figcaption>
                                      )}
                                      {d?.video &&
                                        d?.video?.purchaseStatus === 0 &&
                                        packageStatus?.isTrialUser === false &&
                                        packageStatus?.activePackageLength ===
                                        0 && (
                                          <figcaption className="free_tag">
                                            <span>Free</span>
                                          </figcaption>
                                        )}
                                      <figcaption
                                        className="progress_details"
                                        onClick={handleShow}
                                      >
                                        {parseInt(version?.actual) < 4 &&
                                          getProgressPercentage(d) < 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getProgressPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) > 4 &&
                                          getProgressVideoPercentage(d) <
                                          100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar "
                                                style={{
                                                  width: `${getProgressVideoPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) < 4 &&
                                          getProgressPercentage(d) >= 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed"
                                                style={{
                                                  width: `${getProgressPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) > 4 &&
                                          getProgressVideoPercentage(d) >=
                                          100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed "
                                                style={{
                                                  width: `${getProgressVideoPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                      </figcaption>
                                      <span className="content_ttl">
                                        {d?.video?.title}
                                      </span>
                                    </figure>
                                    <div className="recommend_list_content">
                                      <h6 onClick={handleShow}>
                                        {d?.video?.title ? d?.video?.title : ""}
                                      </h6>
                                      <p onClick={handleShow}>
                                        {d?.video?.author
                                          ? d?.video?.author?.name
                                          : ""}{" "}
                                        <span></span>{" "}
                                        {query1.data.layer
                                          ? query1.data.layer.title
                                          : ""}
                                      </p>
                                      <div
                                        className="rate_timer"
                                        onClick={handleShow}
                                      >
                                        <span>
                                          <img
                                            src={Icons.Star}
                                            alt="Star"
                                            className="img-fluid"
                                          />{" "}
                                          {d?.video?.rating?.length > 1
                                            ? d?.video?.rating
                                            : d?.video?.rating + ".0"}
                                        </span>
                                        {parseInt(version?.actual) < 4 && (
                                          <span>
                                            <img
                                              src={Icons.Clock}
                                              alt="Clock"
                                              className="img-fluid"
                                            />{" "}
                                            {`${getTime(d.video)}`}
                                          </span>
                                        )}
                                        {parseInt(version?.actual) > 4 && (
                                          <span>
                                            <img
                                              src={Icons.Clock}
                                              alt="Clock"
                                              className="img-fluid"
                                            />{" "}
                                            {`${getVideoTime(d.video)}`}
                                          </span>
                                        )}
                                        {d?.video?.isNewVideo !== false && (
                                          <span className="new_tag">New</span>
                                        )}
                                        <span className="play_icn">
                                          <img
                                            src={Icons.Play}
                                            alt="Play"
                                            className="img-fluid"
                                          />
                                        </span>
                                      </div>
                                      {/* <span className="bookmark_icn" onClick={() => bookmarked(d) }>
                                                                                {
                                                                                    d.video.progress.isBookMarked ? (

                                                                                        <img src={Icons.unBookmark} alt="Play" className="img-fluid" />
                                                                                    ) : (

                                                                                        <img src={Icons.Bookmark} alt="Play" className="img-fluid" />
                                                                                    )
                                                                                }
                                                                            </span> */}
                                    </div>
                                  </div>
                                </li>
                              ))}
                            {allVideoList?.length === 0 && (
                              <NoDataFound></NoDataFound>
                            )}
                            {/* <li>
                                                            <div className="recommend_list_main d-flex align-items-center"> 
                                                                <figure className="user_img">
                                                                    <img src={Images.FreeVideoImg} alt="" className="img-fluid"/>
                                                                    <figcaption className="free_tag">
                                                                        <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                                    </figcaption>
                                                                    <figcaption className="progress_details">
                                                                        <div className="progress">
                                                                            <div className="progress-bar" style={{ width: "30%" }}></div>
                                                                        </div>
                                                                        <span className="bookmark_icn">
                                                                            <img src={Icons.Bookmark} alt="Play" className="img-fluid"/>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li> */}
                          </ul>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="started">
                        <div className="recommend_video_details">
                          <ul type="none" className="recommend_list">
                            {notStartList &&
                              notStartList.map((d, i) => (
                                <li>
                                  <div className="recommend_list_main d-flex align-items-center">
                                    <figure
                                      className="user_img"
                                      onClick={handleShow}
                                    >
                                      <img
                                        src={
                                          d?.video?.thumbnail
                                            ? d?.video?.thumbnail
                                            : Images.defaultVideo
                                        }
                                        alt=""
                                        className="img-fluid"
                                      />
                                      {d?.video?.purchaseStatus != 0 && (
                                        <figcaption className="free_tag">
                                          <span>
                                            <img
                                              src={Icons.Lock}
                                              alt="Lock"
                                              className="img-fluid"
                                            />{" "}
                                            Pro
                                          </span>
                                        </figcaption>
                                      )}
                                      {d?.video &&
                                        d?.video?.purchaseStatus === 0 &&
                                        packageStatus?.isTrialUser === false &&
                                        packageStatus?.activePackageLength ===
                                        0 && (
                                          <figcaption className="free_tag">
                                            <span>Free</span>
                                          </figcaption>
                                        )}
                                      {/* <figcaption className="free_tag">
                                                                        <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                                    </figcaption> */}
                                      <figcaption
                                        className="progress_details"
                                        onClick={handleShow}
                                      >
                                        {parseInt(version?.actual) < 4 &&
                                          getProgressPercentage(d) !== 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getProgressPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) > 4 &&
                                          getProgressVideoPercentage(d) !==
                                          100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar "
                                                style={{
                                                  width: `${getProgressVideoPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) < 4 &&
                                          getProgressPercentage(d) === 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed"
                                                style={{
                                                  width: `${getProgressPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) > 4 &&
                                          getProgressVideoPercentage(d) ===
                                          100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed "
                                                style={{
                                                  width: `${getProgressVideoPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                      </figcaption>
                                      <span className="content_ttl">
                                        {d?.video?.title}
                                      </span>
                                    </figure>
                                    <div className="recommend_list_content">
                                      <h6>{d?.video?.title}</h6>
                                      <span
                                        className="name_label"
                                        onClick={handleShow}
                                      >
                                        {d?.video?.author
                                          ? d?.video?.author?.name
                                          : ""}
                                      </span>
                                      <div
                                        className="rate_timer"
                                        onClick={handleShow}
                                      >
                                        <span>
                                          <img
                                            src={Icons.Star}
                                            alt="Star"
                                            className="img-fluid"
                                          />
                                          {d?.video?.rating?.length > 1
                                            ? d?.video?.rating
                                            : d?.video?.rating + ".0"}
                                        </span>
                                        {parseInt(version?.actual) < 4 && (
                                          <span>
                                            <img
                                              src={Icons.Clock}
                                              alt="Clock"
                                              className="img-fluid"
                                            />{" "}
                                            {`${getTime(d?.video)}`}
                                          </span>
                                        )}
                                        {parseInt(version?.actual) > 4 && (
                                          <span>
                                            <img
                                              src={Icons.Clock}
                                              alt="Clock"
                                              className="img-fluid"
                                            />{" "}
                                            {`${getVideoTime(d?.video)}`}
                                          </span>
                                        )}
                                        <span className="play_icn">
                                          <img
                                            src={Icons.Play}
                                            alt="Play"
                                            className="img-fluid"
                                          />
                                        </span>
                                      </div>
                                      {/* <span className="bookmark_icn">
                                                                            {
                                                                                d.video.progress.isBookMarked ? (

                                                                                    <img src={Icons.unBookmark} alt="Play" className="img-fluid" />
                                                                                ) : (

                                                                                    <img src={Icons.Bookmark} alt="Play" className="img-fluid" />
                                                                                )
                                                                            }
                                                                        </span> */}
                                      {/* <img src={Icons.Bookmark} alt="Play" className="img-fluid" /> */}
                                    </div>
                                  </div>
                                </li>
                              ))}
                            {notStartList?.length === 0 && (
                              <NoDataFound></NoDataFound>
                            )}
                            {/* <li>
                                                            <div className="recommend_list_main d-flex align-items-center">
                                                                <figure className="user_img">
                                                                    <img src={Images.FreeVideoImg} alt="" className="img-fluid"/>
                                                                    <figcaption className="free_tag">
                                                                        <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                                    </figcaption>
                                                                    <figcaption className="progress_details">
                                                                        <div className="progress">
                                                                            <div className="progress-bar" style={{ width: "30%" }}></div>
                                                                        </div>
                                                                        <span className="bookmark_icn">
                                                                            <img src={Icons.Bookmark} alt="Play" className="img-fluid"/>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li> */}
                          </ul>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="progress">
                        <div className="recommend_video_details">
                          <ul type="none" className="recommend_list">
                            {countinousList &&
                              countinousList.map((d, i) => (
                                <li>
                                  <div className="recommend_list_main d-flex align-items-center">
                                    <figure
                                      className="user_img"
                                      onClick={handleShow}
                                    >
                                      <img
                                        src={
                                          d?.video?.thumbnail
                                            ? d?.video?.thumbnail
                                            : Images.defaultVideo
                                        }
                                        alt=""
                                        className="img-fluid"
                                      />
                                      {d?.video?.purchaseStatus != 0 && (
                                        <figcaption className="free_tag">
                                          <span>
                                            <img
                                              src={Icons.Lock}
                                              alt="Lock"
                                              className="img-fluid"
                                            />{" "}
                                            Pro
                                          </span>
                                        </figcaption>
                                      )}
                                      {d?.video &&
                                        d?.video?.purchaseStatus === 0 &&
                                        packageStatus?.isTrialUser === false &&
                                        packageStatus?.activePackageLength ===
                                        0 && (
                                          <figcaption className="free_tag">
                                            <span>Free</span>
                                          </figcaption>
                                        )}
                                      {/* <figcaption className="free_tag">
                                                                        <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                                    </figcaption> */}
                                      <figcaption
                                        className="progress_details"
                                        onClick={handleShow}
                                      >
                                        {parseInt(version?.actual) < 4 &&
                                          getProgressPercentage(d) !== 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getProgressPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) > 4 &&
                                          getProgressVideoPercentage(d) !==
                                          100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar "
                                                style={{
                                                  width: `${getProgressVideoPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) < 4 &&
                                          getProgressPercentage(d) === 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed"
                                                style={{
                                                  width: `${getProgressPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) > 4 &&
                                          getProgressVideoPercentage(d) ===
                                          100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed "
                                                style={{
                                                  width: `${getProgressVideoPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                      </figcaption>
                                      <span className="content_ttl">
                                        {d?.video?.title}
                                      </span>
                                    </figure>
                                    <div className="recommend_list_content">
                                      <h6>{d?.video?.title}</h6>
                                      <span
                                        className="name_label"
                                        onClick={handleShow}
                                      >
                                        {d?.video?.author
                                          ? d?.video?.author?.name
                                          : ""}
                                      </span>
                                      <div
                                        className="rate_timer"
                                        onClick={handleShow}
                                      >
                                        <span>
                                          <img
                                            src={Icons.Star}
                                            alt="Star"
                                            className="img-fluid"
                                          />{" "}
                                          {d?.video?.rating?.length > 1
                                            ? d?.video?.rating
                                            : d?.video?.rating + ".0"}
                                        </span>
                                        {parseInt(version?.actual) < 4 && (
                                          <span>
                                            <img
                                              src={Icons.Clock}
                                              alt="Clock"
                                              className="img-fluid"
                                            />{" "}
                                            {`${getTime(d?.video)}`}
                                          </span>
                                        )}
                                        {parseInt(version?.actual) > 4 && (
                                          <span>
                                            <img
                                              src={Icons.Clock}
                                              alt="Clock"
                                              className="img-fluid"
                                            />{" "}
                                            {`${getVideoTime(d?.video)}`}
                                          </span>
                                        )}
                                        <span className="play_icn">
                                          <img
                                            src={Icons.Play}
                                            alt="Play"
                                            className="img-fluid"
                                          />
                                        </span>
                                      </div>
                                      {/* <span className="bookmark_icn">
                                                                            {
                                                                                d.video.progress.isBookMarked ? (

                                                                                    <img src={Icons.unBookmark} alt="Play" className="img-fluid" />
                                                                                ) : (

                                                                                    <img src={Icons.Bookmark} alt="Play" className="img-fluid" />
                                                                                )
                                                                            }
                                                                        </span> */}
                                      {/* <img src={Icons.Bookmark} alt="Play" className="img-fluid" /> */}
                                    </div>
                                  </div>
                                </li>
                              ))}
                            {countinousList?.length == 0 && (
                              <NoDataFound></NoDataFound>
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="completed">
                        <div className="recommend_video_details">
                          <ul type="none" className="recommend_list">
                            {completedList &&
                              completedList.map((d, i) => (
                                <li>
                                  <div className="recommend_list_main d-flex align-items-center">
                                    <figure
                                      className="user_img"
                                      onClick={handleShow}
                                    >
                                      <img
                                        src={
                                          d?.video?.thumbnail
                                            ? d?.video?.thumbnail
                                            : Images.defaultVideo
                                        }
                                        alt=""
                                        className="img-fluid"
                                      />
                                      {d?.video?.purchaseStatus != 0 && (
                                        <figcaption className="free_tag">
                                          <span>
                                            <img
                                              src={Icons.Lock}
                                              alt="Lock"
                                              className="img-fluid"
                                            />{" "}
                                            Pro
                                          </span>
                                        </figcaption>
                                      )}
                                      {d?.video &&
                                        d?.video?.purchaseStatus === 0 &&
                                        packageStatus?.isTrialUser === false &&
                                        packageStatus?.activePackageLength ===
                                        0 && (
                                          <figcaption className="free_tag">
                                            <span>Free</span>
                                          </figcaption>
                                        )}
                                      {/* <figcaption className="free_tag">
                                                                        <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                                    </figcaption> */}
                                      <figcaption className="progress_details">
                                        {parseInt(version?.actual) < 4 &&
                                          getProgressPercentage(d) !== 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getProgressPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) > 4 &&
                                          getProgressVideoPercentage(d) !==
                                          100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar "
                                                style={{
                                                  width: `${getProgressVideoPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) < 4 &&
                                          getProgressPercentage(d) === 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed"
                                                style={{
                                                  width: `${getProgressPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        {parseInt(version?.actual) > 4 &&
                                          getProgressVideoPercentage(d) ===
                                          100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed "
                                                style={{
                                                  width: `${getProgressVideoPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                      </figcaption>
                                      <span className="content_ttl">
                                        {d?.video?.title}
                                      </span>
                                    </figure>
                                    <div className="recommend_list_content">
                                      <h6 onClick={handleShow}>
                                        {d?.video?.title}
                                      </h6>
                                      <span
                                        className="name_label"
                                        onClick={handleShow}
                                      >
                                        {d?.video?.author
                                          ? d?.video?.author?.name
                                          : ""}
                                      </span>
                                      <div
                                        className="rate_timer"
                                        onClick={handleShow}
                                      >
                                        <span>
                                          <img
                                            src={Icons.Star}
                                            alt="Star"
                                            className="img-fluid"
                                          />{" "}
                                          {d?.video?.rating?.length > 1
                                            ? d?.video?.rating
                                            : d?.video?.rating + ".0"}
                                        </span>
                                        {parseInt(version?.actual) < 4 && (
                                          <span>
                                            <img
                                              src={Icons.Clock}
                                              alt="Clock"
                                              className="img-fluid"
                                            />{" "}
                                            {`${getTime(d?.video)}`}
                                          </span>
                                        )}
                                        {parseInt(version?.actual) > 4 && (
                                          <span>
                                            <img
                                              src={Icons.Clock}
                                              alt="Clock"
                                              className="img-fluid"
                                            />{" "}
                                            {`${getVideoTime(d?.video)}`}
                                          </span>
                                        )}
                                        <span className="play_icn">
                                          <img
                                            src={Icons.Play}
                                            alt="Play"
                                            className="img-fluid"
                                          />
                                        </span>
                                      </div>
                                      {/* <span className="bookmark_icn">
                                                                            {
                                                                                d.video.progress.isBookMarked ? (

                                                                                    <img src={Icons.unBookmark} alt="Play" className="img-fluid" />
                                                                                ) : (

                                                                                    <img src={Icons.Bookmark} alt="Play" className="img-fluid" />
                                                                                )
                                                                            }
                                                                        </span> */}
                                      {/* <img src={Icons.Bookmark} alt="Play" className="img-fluid" /> */}
                                    </div>
                                  </div>
                                </li>
                              ))}
                            {completedList?.length == 0 && (
                              <NoDataFound></NoDataFound>
                            )}
                            {/* <li>
                                                            <div className="recommend_list_main d-flex align-items-center">
                                                                <figure className="user_img">
                                                                    <img src={Images.FreeVideoImg} alt="" className="img-fluid"/>
                                                                    <figcaption className="free_tag">
                                                                        <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                                    </figcaption>
                                                                    <figcaption className="progress_details">
                                                                        <div className="progress">
                                                                            <div className="progress-bar" style={{ width: "30%" }}></div>
                                                                        </div>
                                                                        <span className="bookmark_icn">
                                                                            <img src={Icons.Bookmark} alt="Play" className="img-fluid"/>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li> */}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <div className="subjects_wrapper Subject_selection_right_side">
                <div className="subjects_header">
                  <h6>Move to other Topics</h6>
                </div>
                <div className="all_subjects_name_wrapper">
                  <ul type="none" className="subjects_child d-flex flex-wrap">
                    {topiclist &&
                      topiclist
                        .slice()
                        .sort((a, b) => (a.position > b.position ? 1 : -1))
                        .map((d, i) => (
                          <li>
                            <NavLink
                              to={`/videolayer/videolayerContent/${d._id}`}
                              state={topicId}
                            >
                              <div className="subject_main_list d-flex align-itmes-center">
                                <div className="subject_img_wrap d-flex align-items-center">
                                  <figure className="subject_img">
                                    <img
                                      src={
                                        d.icon != ""
                                          ? d.icon
                                          : Images.defaultImg
                                      }
                                      alt=""
                                      className="img-fluid"
                                    />
                                  </figure>
                                  <div className="subject_details">
                                    <h6>{d?.title}</h6>
                                  </div>
                                </div>
                                {
                                  // hide div if percentage gets zero
                                  getPercentage(d) !== 0 && (
                                    <div className="progressbar_wraper d-flex align-items-center">
                                      <div className="progress_details">
                                        <span>{`${getPercentage(d)}%`}</span>
                                        <div className="progress">
                                          <div
                                            className="progress-bar"
                                            style={{
                                              width: `${getPercentage(d)}%`,
                                            }}
                                          ></div>
                                        </div>
                                      </div>
                                      <div className="right_arrow">
                                        <img
                                          src={Icons.VideoArrow}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </div>
                                    </div>
                                  )
                                }
                              </div>
                            </NavLink>
                          </li>
                        ))}
                    {/* <li>
                                                <div className="subject_main_list d-flex align-itmes-center">
                                                    <div className="subject_img_wrap d-flex align-items-center">
                                                        <figure className="subject_img">
                                                            <img src={Icons.Micro} alt="" className="img-fluid" />
                                                        </figure>
                                                        <div className="subject_details">
                                                            <h6>Microbiology</h6>
                                                            <p>Dr.Ashwani Kumar</p>
                                                        </div>
                                                    </div>
                                                    <div className="progressbar_wraper d-flex align-items-center">
                                                        <div className="progress_details">
                                                            <span>40%</span>
                                                            <div className="progress">
                                                                <div className="progress-bar" style={{ width: "30%" }}></div>
                                                            </div>
                                                        </div>
                                                        <div className="right_arrow">
                                                            <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </li> */}
                    {/* <li>
                                            <div className="subject_main_list d-flex align-itmes-center">
                                                <div className="subject_img_wrap d-flex align-items-center">
                                                    <figure className="subject_img">
                                                        <img src={Icons.Micro} alt="" className="img-fluid" />
                                                    </figure>
                                                    <div className="subject_details">
                                                        <h6>Microbiology</h6>
                                                        <p>Dr.Ashwani Kumar</p>
                                                    </div>
                                                </div>
                                                <div className="progressbar_wraper d-flex align-items-center">
                                                    <div className="progress_details">
                                                        <span>40%</span>
                                                        <div className="progress">
                                                            <div className="progress-bar" style={{ width: "30%" }}></div>
                                                        </div>
                                                    </div>
                                                    <div className="right_arrow">
                                                        <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                    </div>
                                                </div>
                                            </div>
                                        </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="video_modal"
        centered
        size="lg"
      >
        {/* <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content"> */}
        {/* <div className="modal-body"> */}
        <Modal.Body>
          <div className="play_back_video">
            {/* <img src={Icons.ModalWarning} alt="warning" className="img-fluid" /> */}
            <img
              src={Images.VideopopupImg}
              alt="warning"
              className="img-fluid"
            />
            {/* <p>Video Play back available only on Mobile App</p> */}
            <span
              className="modal_cross"
              data-dismiss="modal"
              onClick={handleClose}
            >
              <img src={Icons.ModalCross} alt="cross" className="img-fluid" />
            </span>
          </div>
        </Modal.Body>
        {/* </div> */}
        {/* </div> */}
        {/* </div> */}
      </Modal>
      {/* <div className="modal fade video_modal" id="video_play">  
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="play_back_video d-flex align-items-center">
                                <img src={Icons.ModalWarning} alt="warning" className="img-fluid"/>
                                <p>Video Play back available only on Mobile App</p>
                                <span className="modal_cross" data-dismiss="modal" onClick={handleClose}>
                                    <img src={Icons.ModalCross} alt="cross" className="img-fluid"/>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
    </>
  );
}
